export const EMPTY_VALUE = '--';
export const ContractStatus = Object.freeze({
  Active: 'active',
  Completed: 'completed',
  Terminated: 'terminated',
  Draft: 'draft'
});
export const ObjectSource = Object.freeze({
  API: 'API',
  CRM_UI: 'CRM_UI'
});